import { AssignmentColorProps } from 'src/interfaces/assignment.types';

export const ASSIGNMENT_COLORS: AssignmentColorProps[] = [
  { item: '#fbf2c7', img: '#edc96a', date: '#644a07' },
  { item: '#d9f4fc', img: '#2d9ae6', date: '#00438a' },
  { item: '#fddde6', img: '#e59ec6', date: '#8b0450' },
  { item: '#dad6f5', img: '#5d75e9', date: '#151396' },
];

export const DEFAULT_THUMBNAIL_COLOR = '#f7ae88';

export const THUMBNAIL_COLOR_BY_DOMAIN: Record<string, string> = {
  ela: '#6fafff',
  ckla: '#f6e5b4',
  boost: '#aadcdf',
  science: '#d2c0ec',
  math: '#bbebde',
  caminos: '#ebb8b5',
  'mclass-literacy': '#e0b9d0',
  'elementary-literacy-program': '#a7c0dc',
  tutorial: '#f17323',
};
